(() => {
'use strict';
function init(root = document) {
  root.querySelectorAll('[data-nightglow]').forEach((section) => {
    if (section.dataset.ngReady) return;
    section.dataset.ngReady = 'true';
    const image = section.querySelector('[data-ng-main]');
    const thumbs = Array.from(section.querySelectorAll('[data-ng-image]'));
    thumbs.forEach((button) => button.addEventListener('click', () => {
      if (!image || !button.dataset.ngImage) return;
      image.removeAttribute('srcset');
      image.src = button.dataset.ngImage;
      image.alt = button.dataset.ngAlt || 'LED harness product photograph';
      thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }));
    const select = section.querySelector('[data-ng-variant]');
    const price = section.querySelector('[data-ng-price]');
    const button = section.querySelector('[data-ng-add]');
    if (!select || !button) return;
    function sync() {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const available = option.dataset.available === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      button.disabled = !available;
      button.textContent = available ? 'Add harness to bag →' : 'Currently unavailable';
      button.removeAttribute('aria-busy');
    }
    select.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    select.form.addEventListener('submit', () => {
      if (button.disabled) return;
      button.textContent = 'Adding your harness…';
      button.setAttribute('aria-busy', 'true');
    });
    sync();
  });
}
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
})();